<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-user-list">

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <!-- <vs-button color="primary" type="gradient" class="mb-4 md:mb-0" @click="add">Add New Data</vs-button> -->
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ page * per_page - (per_page - 1) }} - {{ row_total - page * per_page > 0 ? page * per_page : row_total }} of {{ row_total }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <vs-input class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="keyword" @keyup="search" placeholder="Search..." />

      </div>
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>No</th>
              <th>Title</th>
              <th>IMEI</th>
              <th>Email</th>
              <th style="min-width: 120px">URL</th>
              <th>Expired</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody v-if="loading">
            <tr>
              <td colspan="12" class="text-center">Loading....</td>
            </tr>
          </tbody>
          <tbody v-else-if="data.length > 0">
            <tr v-for='(item, index) in data' :key='index'>
              <td>{{ ((page-1)*per_page) + (index+1) }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.imei }}</td>
              <td>{{ item.email }}</td>
              <td><a :href="item.url" target="_blank">{{ item.url }}</a></td>
              <td v-if="now > Date.parse(item.expired_date)/1000">
                <vs-chip color="danger">Link Expired</vs-chip>
              </td>
              <td v-else>{{ secondsToHms(Date.parse(item.expired_date)/1000 - now) }}</td>
              <td style="width: 90px">
                <div class="flex">
                  <vx-tooltip v-if="now < Date.parse(item.expired_date)/1000" text="Share Location" position="top">
                    <vs-button :id="`shareBtn${item.imei}`" type="border" size="small" icon-pack="feather" icon="icon-share-2" color="primary" class="mr-2 vs-con-loading__container" @click="share(item.imei, item.url)"></vs-button>
                  </vx-tooltip>
                  <vx-tooltip text="Delete" position="top">
                    <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" color="danger" @click="del(item.id)"></vs-button>
                  </vx-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="12" class="text-center">No Data Available</td>
            </tr>
          </tbody>
        </table>

        <vs-pagination :total="n_page" v-model="page"></vs-pagination>
      </div>

      <vs-popup classContent="popup-example" :title="popupTitle" :active.sync="showPopup">
        <template>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-2/2 w-full">
              <vs-input label="Name" class="w-full" v-model="input.name" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full ml-auto">
              <vs-button id="submitBtn"  class="mr-3 mb-2 vs-con-loading__container" @click="submit">Submit</vs-button>
              <vs-button v-show="action === 'add'" color="warning" type="border" @click="reset" class="mb-2">Reset</vs-button>
            </div>
          </div>
        </template>
      </vs-popup>


      <vs-popup classContent="popup-example" title="Share Location" :active.sync="shareLocPopup">
        <template>
          <div class="vx-row mb-6">
            <div class="vx-col w-full sm:w-1/2 required">
              <vs-input label="Whatsapp Number" class="w-full" v-model="shareData.phone"/>
            </div>
            <div class="vx-col w-full sm:w-1/2 ">
              <vs-button :disabled="!shareData.phone" type="border" color="success" id="createLink"  class="mr-3 mb-2 mt-5 vs-con-loading__container" @click="shareWA">Whatsapp <img src="whatsapp.png" width="13px" alt=""></vs-button>
            </div>
          </div>
        </template>
      </vs-popup>

    </div>
  </div>

</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },

  data () {
    return {
      data: [],
      token: '',
      showPopup: false,
      popupTitle: '',
      action: '',

      loading: true,
      tempId: 0,
      now: new Date().getTime()/1000,
      shareLocPopup: false,

      input: {
          name: '',
      },

      shareData: {
        phone: '',
        url: ''
      },

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error'
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total/this.per_page)
    },
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if(this.page != 1) this.page = 1
      else this.initTable()
    },
  },

  created () {
    this.token = localStorage.getItem('userInfo') !== null ? JSON.parse(localStorage.getItem('userInfo')).token : ''
    this.initTable()
  },

  mounted () {
    setInterval(() => {
      this.now = new Date().getTime()/1000
    }, 1000)
  },

  methods: {
    search() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800);
    },

    updatePerPage(n) {
      this.per_page = n
      this.initTable()
    },

    reset() {
      Object.keys(this.input).map(item => {
        this.input[item] = ''
      })
    },

    initTable() {
      this.loading = true
      this.$http.get(`${this.$api.endpoint}/share_location/datatable?page=${this.page}&per_page=${this.per_page}&search=${this.keyword}`, {
        headers: {
            Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.row_total = res.data.message.total
        this.data = res.data.message.data
        this.loading = false
      }).catch(error => {
        this.$gf.httpErrorHandler(error)
      })
    },


    share(id, url) {
      this.tempId = id
      this.action = 'share'

      this.shareLocPopup = true

      Object.keys(this.shareData).map(item => {
        this.shareData[item] = ''
      })

      this.shareData.url = url

    },

    shareWA() {
      var str = this.shareData.phone

      let fc = str.substr(0,2)
      let lc = str.substr(2)

      let phone = fc.replace('0', '62') + lc

      let url = this.shareData.url

      window.open(`https://this.$api.whatsapp.com/send?phone=${phone}&text=${url}`)
    },

    add() {
      if(this.action === 'edit') this.reset()
      this.action = 'add'
      this.popupTitle = 'Add Shared Location'
      this.showPopup = true
    },

    del(id) {
      this.tempId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Shared Location`,
        text: 'Are you sure want to Delete this Shared Location ?',
        accept: this.confirmDelete
      })
    },

    confirmDelete() {
      this.$http.post(`${this.$api.endpoint}/share_location/delete/${this.tempId}`, {

      }, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      }).then(res => {

        this.notify = res.data.message.split('_').join(' ')

        this.initTable()

        this.$vs.notify({
          title: 'Thank You',
          text: this.notify,
          color: 'success',
          position: 'top-right'
        })
      }).catch(error => {
        this.$gf.httpErrorHandler(error)
      })
    },

    submit() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#submitBtn",
        scale: 0.45
      })

      let url = this.action === 'add' ? `${this.$api.endpoint}/gps_type/add` : `${this.$api.endpoint}/gps_type/update/${this.tempId}`

      this.$http.post(url, {
        name: this.input.name
      },
      {
        headers:{
          Authorization: `Bearer ${this.token}`
        }
      }).then(res => {
        this.$vs.loading.close("#submitBtn > .con-vs-loading")

        this.notify = res.data.message.split('_').join(' ')

        this.showPopup = false
        this.initTable()
        this.reset()

        this.$vs.notify({
          title: 'Thank You',
          text: this.notify,
          color: 'success',
          position: 'top-right'
        })
      }).catch(error => {
        this.$vs.loading.close("#submitBtn > .con-vs-loading")
        this.$gf.httpErrorHandler(error)
      })
    },

    secondsToHms(seconds) {
      // second = 172800
      seconds = Number(seconds);

      let days = seconds > 86400 ? Math.floor(seconds/86400) : 0
      seconds = days > 0 ? seconds - (days*86400) : seconds

      let hour = Math.floor(seconds / 3600)
      let minute = Math.floor(seconds % 3600 / 60)
      let sec = Math.floor(seconds % 3600 % 60)

      let dDisplay = days > 0 ? days + (hour > 0 ? " day(s) " : " day(s)") : ""
      let hDisplay = hour > 0 ? hour.toString().padStart(2, "0") + ":" : "00:"
      let mDisplay = minute > 0 ? minute.toString().padStart(2, "0") + ":" : "00:"
      let sDisplay = sec > 0 ? sec.toString().padStart(2, "0") : "00"
      return dDisplay + hDisplay + mDisplay + sDisplay
    },
  },
}

</script>
